import Rollbar from 'rollbar'
import options from './lib/options'

if (process.env.ROLLBAR_ACCESS_TOKEN && process.env.ROLLBAR_ENVIRONMENT) {
  window.Rollbar = new Rollbar(options)
}
